import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { JsonViewer } from '@dataxpdtn/mui-json-viewer';
import config from '@iotv/config';
import { Milliseconds } from '@iotv/iotv-v3-types';
import { Stack, Typography } from '@mui/material';
import { useContext } from 'react';
import { LogViewerContext } from './LogViewerConstants';
export const LogItems = ({ logs }) => {
    return (_jsx(Stack, { children: logs.map((log) => (_jsx(SingleLogItem, { log }, log.functionName + log.timestamp + log.level))) }));
};
const SingleLogItem = ({ log }) => {
    const { state: { groupArraysAfterLength }, } = useContext(LogViewerContext);
    const { level, message, timestamp } = log;
    const clonedMessages = [...message];
    const ms = timestamp % Milliseconds.SECOND;
    const date = new Date(timestamp);
    const rootName = `${level}: ${date.toLocaleString(config.locale, { hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: 'numeric' })}:${ms}`;
    const textEntries = [];
    while (typeof clonedMessages.at(0) === 'string') {
        let textEntry = clonedMessages.shift();
        if (textEntries.length === 0) {
            textEntry = `${rootName}: ${textEntry}`;
        }
        textEntries.push(textEntry);
    }
    return (_jsxs(Stack, { children: [_jsx(Stack, { sx: {
                    color: (t) => {
                        switch (level) {
                            case 'SPECIAL':
                            case 'SYSTEM':
                            case 'TRACE':
                            case 'DEBUG':
                                return t.palette.primary.contrastText;
                            case 'INFO':
                                return t.palette.info.main;
                            case 'WARN':
                                return t.palette.warning.main;
                            case 'ERROR':
                            case 'FATAL':
                                return t.palette.error.main;
                        }
                    },
                }, children: textEntries.map((t) => (_jsx(Typography, { color: "inherit", children: t }, t))) }), clonedMessages.length > 0
                ? clonedMessages.map((msg) => (_jsx(JsonViewer, { value: msg,
                    objectSortKeys: true,
                    displayComma: false,
                    displaySize: false,
                    collapseStringsAfterLength: 300,
                    quotesOnKeys: false,
                    displayDataTypes: false,
                    rootName: '',
                    enableClipboard: true,
                    groupArraysAfterLength: groupArraysAfterLength ?? undefined,
                    keyRenderer: undefined,
                    defaultInspectDepth: 3,
                    editable: false,
                    sx: { fontFamily: 'monospace', fontSize: 20, font: 'inherit' } }, msg)))
                : null] }, timestamp));
};
